import React from 'react';
import AsyncSelect from 'react-select/async';
import { useAppDispatch } from '../../../app/hooks';
import {
  getOwnerAutoCompleteOptionsAsync,
  OwnerAutoCompleteOption,
} from '../../../features/Users/identityUsersSlice';

export interface OwnerOptionType {
  value: string;
  label: string;
}

interface OwnerQuickSearchProps {
  Placeholder?: string;
  parentHandleSelectOwnerChange: (
    selectedOwner: OwnerOptionType | null,
  ) => void;
  selectedOwnerOptionType?: OwnerOptionType | null;
}

const OwnerQuickSearch = ({
  Placeholder = 'Hae omistajan numerolla tai nimellä...',
  parentHandleSelectOwnerChange,
  selectedOwnerOptionType,
}: OwnerQuickSearchProps) => {
  const dispatch = useAppDispatch();

  const handleSelectOwnerChange = (selectedOption: OwnerOptionType) => {
    if (selectedOption && selectedOption.label && selectedOption.value) {
      const ownerId = selectedOption.value;
      if (parentHandleSelectOwnerChange !== undefined) {
        parentHandleSelectOwnerChange(selectedOption);
      }
    } else if (parentHandleSelectOwnerChange !== undefined) {
      parentHandleSelectOwnerChange(null);
    }
  };

  // Transform fetched options to match react-select format
  const formatOptions = (
    options: OwnerAutoCompleteOption[] | undefined,
  ): OwnerOptionType[] => {
    if (!options || options.length === 0) {
      return [];
    }

    const newOptions = options.map(option => ({
      value: option.ownerId,
      label: `${option.ownerNumber} - ${option.firstName} ${option.lastName}`,
    }));
    return newOptions;
  };

  const loadOptions = async (
    inputValue: string,
  ): Promise<OwnerOptionType[]> => {
    try {
      const response = await dispatch(
        getOwnerAutoCompleteOptionsAsync(inputValue),
      );
      // Access response data and format the options
      return formatOptions(response.payload.data);
    } catch (error) {
      console.error('Error fetching options:', error);
      return [];
    }
  };

  return (
    <div>
      <AsyncSelect
        styles={{
          control: baseStyles => ({
            ...baseStyles,
            borderColor: '#ced4da',
            borderRadius: 6,
          }),
          dropdownIndicator: baseStyles => ({
            ...baseStyles,
            visibility: 'hidden',
          }),
          indicatorSeparator: baseStyles => ({
            ...baseStyles,
            visibility: 'hidden',
          }),
        }}
        classNames={{
          control: state => 'form-control form-control-search ps-48 pe-8',
        }}
        inputId="ownerId"
        name="ownerId"
        placeholder={Placeholder}
        isClearable
        isSearchable
        loadOptions={loadOptions}
        cacheOptions
        onChange={option => handleSelectOwnerChange(option)}
        value={selectedOwnerOptionType}
      />
    </div>
  );
};

export default OwnerQuickSearch;
export { OwnerQuickSearch };
export type { OwnerQuickSearchProps };
